import { createComponent, createSignal } from "solid-js";
import { render } from "solid-js/web";
import { SelectionTab, type SelectionActions, type Shown } from "../console/SelectionTab";
import type { Header } from "../replay/format";
import type { Pick, Renderer } from "../render/renderer";
import type { WorldState } from "../state/world";
import { $ } from "./format";

export type InspectorActions = SelectionActions;

/** Shows the selected unit, or else the hovered (or clicked) hex, in the
 *  Selection tab (a Solid component, `console/SelectionTab`). */
export class Inspector {
  private lastKey = "";
  private setShown: (v: Shown) => void;
  private dispose: () => void;

  constructor(
    header: Header,
    private state: WorldState,
    renderer: Renderer,
    private actions: InspectorActions,
  ) {
    const [shown, setShown] = createSignal<Shown>(null, { equals: false });
    this.setShown = setShown;
    this.dispose = render(() => createComponent(SelectionTab, { header, state, renderer, actions, shown }), $("inspector"));
  }

  update(selected: number | null, hover: Pick | null): void {
    const s = this.state;
    // Rebuild only when what's shown changes.
    const key =
      selected !== null
        ? `u${selected}:${s.frame}:${s.alive[selected]}:${this.actions.following()}`
        : hover?.tile != null
          ? `t${hover.tile}:${s.frame}`
          : "none";
    if (key === this.lastKey) return;
    this.lastKey = key;
    this.setShown(selected !== null ? { kind: "unit", id: selected, frame: s.frame } : hover?.tile != null ? { kind: "tile", pick: hover, frame: s.frame } : null);
  }

  destroy(): void {
    this.dispose();
  }
}
